import { useSyncExternalStore } from 'react';

/**
 * Tracks whether any DocSheet is open. Used to suspend heavy background views
 * (flow canvas, mission chrome) so typing in the doc editor isn't competing
 * with hundreds of mounted nodes and observers behind the sheet.
 *
 * Also toggles `body.doc-sheet-open` — a cheap class hook for CSS that used
 * to rely on `body:has(.doc-sheet--open)` (re-evaluated on every DOM change
 * under body, including each keystroke in a code block).
 */
let openCount = 0;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn());

export const getDocSheetOpen = () => openCount > 0;

export const subscribeDocSheetOpen = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const setDocSheetOpen = (open) => {
  const next = open ? openCount + 1 : Math.max(0, openCount - 1);
  if (next === openCount) return;
  openCount = next;
  if (typeof document !== 'undefined') {
    if (openCount > 0) document.body.classList.add('doc-sheet-open');
    else document.body.classList.remove('doc-sheet-open');
  }
  emit();
};

export const useDocSheetOpen = () =>
  useSyncExternalStore(subscribeDocSheetOpen, getDocSheetOpen, () => false);
